"use client";

import type { AgentationProps } from "agentation";
import dynamic from "next/dynamic";

const Agentation = dynamic<AgentationProps>(
	() => import("agentation").then((module) => module.Agentation),
	{ ssr: false },
);

const defaultEndpoint = "http://localhost:4747";

export function AgentationDevtools() {
	if (process.env.NODE_ENV !== "development") {
		return null;
	}

	return <Agentation endpoint={process.env.NEXT_PUBLIC_AGENTATION_ENDPOINT ?? defaultEndpoint} />;
}
